var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Grid, TextField, FormControlLabel, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { session as sessionApi } from '../api';
import { useNotify } from '../hooks/notificationHook';
import BaseButton from './atoms/BaseButton';
import SessionContainer from './SessionContainer';
import SessionLinks from './SessionLinks';
import { useRequest } from '../hooks/requestHook';
import NewRoasterCampaignLabel from './atoms/NewRoasterCampaignLabel';
var StyledNewRoasterCampaignLabel = styled(NewRoasterCampaignLabel)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: red;\n  cursor: pointer;\n  text-decoration: underline;\n"], ["\n  color: red;\n  cursor: pointer;\n  text-decoration: underline;\n"])));
var RegisterForm = function (_a) {
    var role = _a.role;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var navigate = useNavigate();
    var notify = useNotify();
    var _c = React.useState(false), registered = _c[0], setRegistered = _c[1];
    var _d = React.useState(false), accepted = _d[0], setAccepted = _d[1];
    var nameRef = React.createRef();
    var emailRef = React.createRef();
    var passwordRef = React.createRef();
    var register = useRequest(sessionApi.register);
    var showAccountLinks = role !== 'admin';
    React.useEffect(function () {
        if (registered)
            navigate("/".concat(role, "/login"));
    }, [navigate, role, registered]);
    var handleRegister = React.useCallback(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var name, email, password, properRole, response;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setRegistered(false);
                    event.preventDefault();
                    name = (_a = nameRef.current) === null || _a === void 0 ? void 0 : _a.value;
                    email = (_b = emailRef.current) === null || _b === void 0 ? void 0 : _b.value;
                    password = (_c = passwordRef.current) === null || _c === void 0 ? void 0 : _c.value;
                    properRole = ['producer', 'roaster'].includes(role);
                    if (!name || !email || !password || !properRole)
                        return [2 /*return*/];
                    return [4 /*yield*/, register({ name: name, email: email, password: password, role: role })];
                case 1:
                    response = _d.sent();
                    if (!response)
                        return [2 /*return*/];
                    setRegistered(true);
                    notify('success', [
                        t('messages.registerSuccess', {
                            email: email,
                        }),
                    ]);
                    return [2 /*return*/];
            }
        });
    }); }, [nameRef, emailRef, passwordRef, t, notify, role, register]);
    var handleChangeAccepted = React.useCallback(function (event) {
        setAccepted(event.target.checked);
    }, [setAccepted]);
    var termLocale = React.useMemo(function () {
        if (role === 'producer') {
            return i18n.language === 'ja' ? 'ja' : 'en';
        }
        return i18n.language;
    }, [role, i18n.language]);
    return (React.createElement(SessionContainer, { role: role },
        React.createElement("form", null,
            React.createElement(Grid, { container: true, spacing: 3 },
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(Grid, { container: true, spacing: 2 },
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextField, { inputRef: nameRef, fullWidth: true, label: t('name'), name: "name", size: "small", variant: "outlined" })),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextField, { inputRef: emailRef, fullWidth: true, label: t('email'), name: "email", size: "small", variant: "outlined" })),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextField, { inputRef: passwordRef, fullWidth: true, label: t('password'), name: "password", size: "small", type: "password", variant: "outlined" })))),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement("iframe", { width: "100%", src: "/term.html?role=".concat(role, "&locale=").concat(termLocale), height: "150px" }),
                    React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: accepted, onChange: handleChangeAccepted }), label: t('pages.register.accept') })),
                React.createElement(Grid, { item: true, xs: 1 }),
                React.createElement(Grid, { item: true, xs: 10 },
                    React.createElement(BaseButton, { fullWidth: true, type: "submit", onClick: handleRegister, disabled: !accepted }, t('register')),
                    React.createElement(SessionLinks, { role: role, showLogin: true, showReconfirmEmail: showAccountLinks })),
                role === 'roaster' && (React.createElement(React.Fragment, null,
                    React.createElement(Grid, { item: true, xs: 1 }),
                    React.createElement(Grid, { item: true, xs: 12, style: { textAlign: 'center' } },
                        React.createElement(StyledNewRoasterCampaignLabel, { variant: "subtitle1" }))))))));
};
export default RegisterForm;
var templateObject_1;
